import React from 'react';
import { Row, Col } from 'antd';
import {verifIsLogged, setDisconnectMachineId, getMachineId, getPays, setLanguage, getLanguage} from "../util/Toolbox";
import { withTranslation } from 'react-i18next';

import './css/home.css';
import './css/navBar.css';

import analyse_picto_bleu         from "./assets/home/1_Analyse_d_eau.svg";
import calcul_picto               from './assets/home/2_Volume.svg';
import ordonnance_picto           from './assets/home/3_Historique.svg';
import admin_picto                from './assets/home/5_Administration.svg';
import spintouch_picto            from './assets/home/4_Spin_touch.svg';
import background_home            from './assets/home/1_Home-1920x1080.png';
import axios                      from '../util/Api'
import ElectronWaterLinkService   from '../services/ElectronWaterLinkService'
import NavBar                     from '../components/NavBar';
import Footer                     from '../components/Footer';

class Home extends React.Component {

  state = {
    conseil_LIST : [],
    IsAdmin : false,
    languages_LIST : [],
    language : getLanguage(),
    isElectron: false,
    // États pour la mise à jour
    updateStatus: 'checking', // 'checking' | 'available' | 'current' | 'error'
    backendVersion: null,
    electronVersion: null,
  }

  async componentDidMount() {

    verifIsLogged();

    let languages_LIST = getPays();

    this.setState({languages_LIST : languages_LIST});

    let guid_compte = getMachineId();

    this.state.guid_compte = guid_compte;

    const {i18n } = this.props;
    let newLang = getLanguage();
    i18n.changeLanguage(newLang);
    setLanguage(newLang);
    this.setState({language : newLang});

    // Détection de l'environnement Electron pour contrôler l'affichage Spintouch
    let isElectron = ElectronWaterLinkService.isElectronApp();
   // isElectron = true;
    this.setState({ isElectron  });

    // Vérifier les mises à jour si dans Electron
    if (isElectron) {
      this.checkForUpdates();
    }

    // On regarde accès admin pour cet utilisateur
    axios.get(`analyse/${this.state.guid_compte}/loadProfile`,
    ).then(({data}) => {

      if(data.success == 'success'){
        if(data.user.IsAccesBack == 1){
          //console.log("admin");
          this.setState({IsAdmin : true})
        }else{
          //console.log("simple");
          this.setState({IsAdmin : false})
        }

      }

    }).catch(function (error) {
      console.log("Error****:", error.message);
      this.setState({isLoading : false})
    });

  }

  async checkForUpdates() {
    if (!this.state.isElectron) {
      return;
    }

    try {
      // Récupérer la version Electron
      let electronVersion = window.electronAPI?.version;

      console.log('electronVersion', electronVersion);

     /// electronVersion = '1.1.0';

      
      if (!electronVersion) {
        console.warn('Version Electron non disponible');
        this.setState({
          updateStatus: 'error',
          electronVersion: null
        });
        return;
      }
        

      console.log('analyse/version')
      // Récupérer la version de l'API backend
      const response = await axios.get('analyse/version');

      console.log(response);

      if (response.data.success === 'success' && response.data.version) {
        const backendVersion = response.data.version.NumeroVersion;

        // Normaliser les versions pour comparaison (enlever "v" si présent)
        const normalizeVersion = (v) => v.replace(/^v/, '').trim();
        const updateAvailable = normalizeVersion(backendVersion) !== normalizeVersion(electronVersion);

        this.setState({
          updateStatus: updateAvailable ? 'available' : 'current',
          backendVersion: backendVersion,
          electronVersion: electronVersion
        });
      } else {
        this.setState({ updateStatus: 'error' });
      }
    } catch (error) {
      console.error('Erreur lors de la vérification des mises à jour:', error);
      this.setState({ updateStatus: 'error' });
    }
  }

    // Fonction pour changer la langue
  handleChangeLanguage = (event) => {
      const newLang = event.target.value;
      // Définir la langue  
      const {i18n } = this.props;
      console.log(newLang);
      i18n.changeLanguage(newLang);
      setLanguage(newLang);
      this.setState({language : newLang});
  };

  onClickDisconnect = () => {
    setDisconnectMachineId();
  }

  render() {

    const { t, i18n } = this.props; // Récupérer la traduction et le changement de langue

      return (

        <div style={{
          backgroundColor: 'black',
          backgroundImage: `url(${background_home})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          backgroundAttachment: 'fixed',
          minHeight: '100vh',
          paddingBottom: 0,
          marginBottom: 0,
          display: 'flex',
          flexDirection: 'column'
        }}>

          <div className = "wrapper_home">

            <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1"/>

              <NavBar
                t={t}
                isElectron={this.state.isElectron}
                updateStatus={this.state.updateStatus}
                IsAdmin={this.state.IsAdmin}
              />

              <div className = "containersHome">
                <div className='containerHero'>
                  
                  <div className='textHero'>{t('hero_title1')}<span style={{ color: 'white', fontWeight: '600'}}>{t('hero_title2')}</span></div>
                 
                </div>

                <div>

                  <Row style = {{ marginTop:100, textAlign : 'center'}} gutter={[30, 30]}>

                    <Col xs={12} sm={12} md={6} lg={6} xl={6} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRECTANGULAIRE}>
                      <div  className= "homeMenuCell">
                        <a href = "/forms"><img loading="lazy"  src={analyse_picto_bleu} width ="130px"  height ="130px" />
                          <p className= "button_home">{t('home_analyse')}</p>
                        </a>
                      
                      </div>
                    </Col>

                    <Col  xs={12} sm={12} md={6} lg={6} xl={6} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationOVALE}>
                      <div className= "homeMenuCell">
                        <a href = "/simulateur"><img  loading="lazy" src={calcul_picto}  width ="130px"  height ="130px" />
                          <p className= "button_home">{t('home_calcule')}</p>
                        </a>
                      
                      </div>
                    </Col>

                  <Col  xs={12} sm={12} md={6} lg={6} xl={6} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRONDE}>
                    <div className= "homeMenuCell">
                      <a href = "/historique"><img loading="lazy"  src={ordonnance_picto}   width ="180px"  height ="180px" />
                      <p className= "button_home">{t('home_enregistre')}</p>
                      </a>
                    </div>
                  </Col>

                  {  this.state.isElectron == true &&
                    <Col  xs={12} sm={12} md={6} lg={6} xl={6} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRONDE}>
                      <div className= "homeMenuCell">
                          <a href = "/spintouch"><img loading="lazy"  src={spintouch_picto}   width ="180px"  height ="180px" />
                        <p className= "button_home">{t('home_spintouch')}</p>
                        </a>
                      </div>
                    </Col>
                  }

                  { this.state.IsAdmin == true &&
                    <Col  xs={12} sm={12} md={5} lg={5} xl={5} style={{ cursor: 'pointer'}}  span={8} onClick= {this.validationRONDE}>
                      <div className= "homeMenuCell">
                        <a href = "/administration"><img loading="lazy"  src={admin_picto}   width ="180px"  height ="180px" />
                        <p className= "button_home">{t('home_admin')}</p>
                        </a>
                      </div>
                    </Col>
                  }

                 </Row>

                </div>

                

                

              </div>

          </div>

          <Footer />

        </div>

      )

    };
}


export default withTranslation() (Home);


/*
 <li>
                        <select
                          id="language-select"
                          value={this.state.language}
                          disabled = {false}
                          onChange={this.handleChangeLanguage}
                          style={{ padding: '5px', fontSize: '16px', cursor: 'pointer' }}
                        >
                          {this.state.languages_LIST.map((lang) => (
                            <option key={lang.code} value={lang.code}>
                              {lang.flag} {lang.label}
                            </option>
                          ))}
                        </select>
                      </li>
*/


